import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import vuetify from "./plugins/vuetify";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import 'cropperjs/dist/cropper.css';

Vue.use(VueToast,{
  position:"top-right",
  duration:0
})

// add these before Vue is instantiated
axios.defaults.baseURL = "https://api.legalcasebilling.co.za";

Vue.config.productionTip = false;
Vue.prototype.axios = axios;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
